




























































































































































import { Component, Vue, Prop } from 'vue-property-decorator';
import * as Common from '@/tenant/common';
import * as Components from '@/tenant/components';
import { Currency, GetSystemCurrecy, RoundTypes } from '@/tenant/models/All';

@Component
export default class StockTakingItemView extends Vue {
  public items: Common.StockTransferItem[] = new Array(0);
  public params: Common.StockTransferItemQuery = new Common.StockTransferItemQuery();
  public importQuery = new Common.ImportQuery('在庫振替明細','StockTransferItem');
  public exportQuery = new Common.StockTransferItemExportQuery('在庫振替明細',this.params);
    public usedTypes = Common.UsedTypes;
  public sortOptions: any = [
    { value: 'state', text: '状態' },
    { value: 'stockTransferItemNo', text: '明細番号' },
    { value: 'transferFlag', text: '振替区分' },
    { value: 'bookDate', text: '発生日' },
    { value: 'salesPurchaseFlag', text: '入出庫区分' },
    { value: 'commodity', text: '商品' },
    { value: 'stockTransferNo', text: '在庫振替番号' },
    { value: 'warehouseOut', text: '出庫倉庫' },
    { value: 'warehouseIn', text: '入庫倉庫' },
    { value: 'segmentOut', text: '出庫部門' },
    { value: 'segmentIn', text: '入庫部門' },
    { value: 'pic', text: '担当者' },
    { value: 'refNo', text: '管理番号' },
    { value: 'initialSavedOn', text: '初回保存日' },
    { value: 'initialSavedBy', text: '初回保存者' },
    { value: 'lastUpdatedOn', text: '最終更新日' },
    { value: 'lastUpdatedBy', text: '最終更新者' },
  ];
  @Prop() public stockTransferNo:string;
  @Prop() public stockTransferItemNo:string;
  @Prop({default:null}) public popup: Components.PopupEditor; 

  public savingFlag: Common.StockBalanceJournalStatus = Common.StockBalanceJournalStatus.StockTransferWaiting;
  public visibleTypes = Common.visibleTypes;  
  public tenantSettings: Common.TenantSettings = null;  
  public gridConfig:Common.GridConfiguration = new Common.GridConfiguration([],0, 'grid');

  public created() {

    this.tenantSettings = this.$api.tenantSettings;
    this.gridConfig.setGridItemsFromCaptions(
      [ '状態','明細番号', '振替区分','発生日',  '入出庫区分', '商品','SKU', '単位',  '振替数量', '振替単価', '振替金額', '在庫振替番号', '出庫倉庫',  '入庫倉庫', '出庫部門','入庫部門','案件','担当者', '管理番号', '初回保存日', '初回保存者', '最終更新日', '最終更新者'],
      [150, 180, 150, 150, 150, 150, 150, 150, 150, 150, 150, 150, 150, 150, 150, 150,150, 150, 150, 150, 150, 150, 150, 150, 150, 150, 150, 150]
    );
    this.gridConfig.setGridItems(...this.tenantSettings.GetGridItems(true,true,true,false,false));
    // 検索条件を設定する
    if(this.stockTransferNo){
      this.params.stockTransferNo = this.stockTransferNo;
      this.params.state = null;
    }
    if(this.stockTransferItemNo) {
      this.params.stockTransferItemNo = this.stockTransferItemNo;
      this.params.state = null;
    }
    if(!this.stockTransferNo && !this.stockTransferItemNo){
      this.params.holder = this.$api.license.countOnlyOwned ? this.$api.auth.userId : "";
		}
    //タスク表示モードの設定(全件/未完了)
    if (this.$api.onlyOpen == false) this.params.state = null;
            
  }

  public async onCreate(obj: Common.StockTakingItem) {
    // const workflows = this.$api.formatter.getOptions('workflow_stockTransferItem');
    // if (workflows.length > 0) obj.workflowId = workflows[0].value;
    return Promise.resolve(obj);
  }

  public onWorkflow(index: number, obj: any) {
    this.$set(this.items, index, obj);
  }

  // 在庫振替一覧へ遷移する
  public getStockTransferLinkFormat(item : Common.StockTransferItem){
    return '/journal/StockTransfer?stockTransferNo={0}';
  }

  // 振替数量の活性制御
  public isEditableQuantity(item:Common.StockTransferItem):boolean{
    if(item.state == this.savingFlag && item.stockTransfer.transferFlag == Common.TransferTypes.Transfer) return true;
    return false;
  }

  // 振替数量変更時の項目設定
  public setTransferQuantity(item:Common.StockTransferItem){
    if(item.salesPurchaseFlag == Common.SalesPurchaseFlags.Sales) {
      item.amount = new Common.CalcUtil().Round(item.unitPrice * item.quantity,this.$api.systemCurrencyPrecision,this.$api.systemCurrencyRoundType);
    }
    else
    {
      if(item.quantity == 0) item.unitPrice = 0;
      else item.unitPrice = new Common.CalcUtil().Round(item.amount / item.quantity, item.commodity.stockPriceScale, item.commodity.stockPriceRound);
    }
  }

  // 振替単価の活性制御
  public isEditablePrice(item:Common.StockTransferItem):boolean{
    if(item.state == this.savingFlag && item.salesPurchaseFlag == Common.SalesPurchaseFlags.Sales) return true;
    return false;
  }

  // 振替単価変更時の項目設定
  public setTransferPrice(item:Common.StockTransferItem){
    if(item.salesPurchaseFlag == Common.SalesPurchaseFlags.Sales) 
      item.amount = new Common.CalcUtil().Round(item.unitPrice * item.quantity,this.$api.systemCurrencyPrecision,this.$api.systemCurrencyRoundType);
  }

  // 振替金額の活性制御
  public isEditableAmount(item:Common.StockTransferItem):boolean{
    if(item.state == this.savingFlag && item.salesPurchaseFlag == Common.SalesPurchaseFlags.Purchase) return true;
    return false;
  }

  // 振替金額変更時の項目設定
  public setTransferAmount(item:Common.StockTransferItem){
    if(item.salesPurchaseFlag == Common.SalesPurchaseFlags.Purchase) 
    {
      if(item.quantity == 0) item.unitPrice = 0;
      else item.unitPrice = new Common.CalcUtil().Round(item.amount / item.quantity, item.commodity.stockPriceScale, item.commodity.stockPriceRound);
    }
  }
}
